import { keepPreviousData, useQuery } from "@tanstack/react-query";
import type { UserActivityFilters, UserActivityResponse } from "../api/userActivityApi";
import { fetchUserActivity } from "../api/userActivityApi";

export const userActivityKeys = {
  all: ["user-activity"] as const,
  list: (filters: UserActivityFilters) => [...userActivityKeys.all, "list", filters] as const,
};

export const useUserActivityQuery = (filters: UserActivityFilters) =>
  useQuery<UserActivityResponse>({
    queryKey: userActivityKeys.list(filters),
    queryFn: () => fetchUserActivity(filters),
    placeholderData: keepPreviousData,
  });
